module.exports = __webpack_public_path__ + "img/logo_curi_insurance_white_horizontal.2985a089.svg";